module.exports = __webpack_public_path__ + "img/sect4-444.60562bbe.png";